export default {
  getQuestionAnswer: '/questionnaires/api/{0}/getPaperAnswers/{1}', // 获取医院调查问卷答案
  getQuestionnaireInfo: '/questionnaires/api/{0}/hosPapers', // 医院调查问卷调取
  submitQuestionnaireInfo: '/questionnaires/api/{0}/saveHosPapers', // 医院调查问卷提交
  restrictQuestionnaireInfo: '/questionnaires/api/{0}/checkHosPapers', // 医院调查问卷限制
  submitDiseasesQuestionnaireInfo: '/questionnaires/api/diseaseQuestionnaire/add' // 慢病筛查调查问卷
};
